module.exports = __webpack_public_path__ + "static/media/03f8a04e-811d-483f-a425-e02d5060e55e.e789f37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/03f8a04e-811d-483f-a425-e02d5060e55e.png
// module id = 1467
// module chunks = 0